import React from "react";
import type { ReactNode } from "react";
import { useTier } from "./tierContext";

const LEVEL_ORDER: Record<string, number> = {
  standard: 1,
  advanced: 2,
};

interface FeatureGateProps {
  feature: string;
  minLevel?: string;
  children: ReactNode;
  fallback?: ReactNode;
}

export default function FeatureGate({
  feature,
  minLevel,
  children,
  fallback = null,
}: FeatureGateProps) {
  const { hasFeature, getFeatureLevel, loading } = useTier();

  if (loading) return null;

  if (!hasFeature(feature)) return <>{fallback}</>;

  if (minLevel) {
    const currentLevel = getFeatureLevel(feature);
    const currentRank = LEVEL_ORDER[currentLevel ?? ""] ?? 0;
    const requiredRank = LEVEL_ORDER[minLevel] ?? 0;
    if (currentRank < requiredRank) return <>{fallback}</>;
  }

  return <>{children}</>;
}
